(function ($) {
  $(document).ready(function () {
    // Getting localized data.
    var additionalImageObj = localizedData.additionalImageScript;
    $(document).ready(function ($) {
      $("#selected_park").select2({
        allowClear: true, // Option to clear the selection
      });
    });
    // Handle click on the label to trigger file selection
    $("#drop-area").on("click", function (event) {
      // Prevent the click event from propagating to the file input directly
      event.stopPropagation();
    });

    // Prevent file input's default click event from triggering again
    $("#file_input").on("click", function (event) {
      event.stopPropagation();
    });

    // Display file name on file selection
    $("#file_input").on("change", function (event) {
      let file = event.target.files[0];
      if (file) {
        $("#file-name").text(file.name); // Display the file name
      } else {
        $("#file-name").text(""); // Clear the file name if no file is selected
      }
    });

    // Drag and drop functionality
    $("#drop-area").on("dragover", function (event) {
      event.preventDefault();
      event.stopPropagation();
      $(this).addClass("dragging");
    });

    $("#drop-area").on("dragleave", function (event) {
      event.preventDefault();
      event.stopPropagation();
      $(this).removeClass("dragging");
    });

    $("#drop-area").on("drop", function (event) {
      event.preventDefault();
      event.stopPropagation();
      $(this).removeClass("dragging");

      let files = event.originalEvent.dataTransfer.files;
      $("#file_input").prop("files", files);

      if (files.length > 0) {
        $("#file-name").text(files[0].name); // Display the file name
      } else {
        $("#file-name").text(""); // Clear the file name if no file is selected
      }
    });

    // Handle form submission
    $("#form-additional-images").on("submit", function (event) {
      event.preventDefault();

      $("#zip-error-message").empty();
      $("#zip-success-message").empty();

      let selectedSpecies = $("#selected_species").val();
      let fileInput = $("#file_input")[0].files[0];
      let description = $("#photo_description").val();
      let errorMessage = "";

      if (!selectedSpecies) {
        errorMessage += "Please select a species.<br>";
      }

      if (!fileInput) {
        errorMessage += "Please select a .zip file to upload.<br>";
      } else if (fileInput.size > 52428800) {
        errorMessage += "File size exceeds 50 MB.<br>";
      } else if (fileInput.type !== "application/zip") {
        errorMessage += "File format must be .zip.<br>";
      }

      if (errorMessage) {
        $("#zip-error-message").html(errorMessage);
        return;
      }

      let formData = new FormData();
      formData.append("action", "submit_additional_images");
      formData.append("nonce", additionalImageObj.submit_additional_img_nonce);
      formData.append("selected_species", selectedSpecies);
      formData.append("zip_file", fileInput);
      formData.append("description", description);

      $("#form-additional-images input[type=submit]").attr(
        "disabled",
        "disabled"
      );
      $(".zip-file-loader").show();

      $.ajax({
        url: additionalImageObj.ajax_url,
        method: "POST",
        data: formData,
        processData: false,
        contentType: false,
        success: function (response) {
          if (response.success) {
            $("#form-additional-images input[type=submit]").removeAttr(
              "disabled"
            );
            $(".zip-file-loader").hide();
            $("#form-additional-images")[0].reset();
            $("#zip-success-message").html(response.data);
          } else {
            $("#zip-error-message").html(response.data);
          }
        },
        error: function () {
          $("#form-additional-images input[type=submit]").removeAttr(
            "disabled"
          );
          $(".zip-file-loader").hide();
          $("#zip-error-message").html("An error occurred. Please try again.");
        },
      });
    });

    // Handle to show popup.
    $("#upload-additional-images-btn").on("click", function (event) {
      event.preventDefault();
      $("#modal-additional-images-wrapper").show();
      $("#zip-error-message").empty();
      $("#zip-success-message").empty();
    });

    // For closing additional pop-up.
    $(document).on("click", ".additional-image-pop-up-close", function () {
      $(this).closest(".npx-popup-wrapper").hide();
    });
  });
})(jQuery);
